import { isomorphicRedirectTo, PERM_REDIRECT } from 'helpers/navigation'
import { FetchProps } from 'helpers/redial'

export default {
  fetch: async ({ store, service }: FetchProps) => {
    const data = await service.blackFriday.request()

    store.blackFridayPage.setBlackFridayPlaceholders(data)

    const placeholders = store.blackFridayPage.placeholders

    if (!placeholders['{{BF-LP-TITLE}}']) {
      isomorphicRedirectTo({
        to: '/',
        status: PERM_REDIRECT,
        urlManager: store.urlManager,
        router: store.router,
      })
    }
  },
}
